import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import { StockType } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { StockInputValue_Edit_NoOption } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';
import { html } from 'rune-ts';
import klass from './Input_Stock.module.scss';
import common_klass from '../../section-views/styles/common.module.scss';
import { Base_Input_Stock } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Base_Input_Stock.ts';
import { stockDataUtil } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/util.ts';
import { doIf } from '@services/MarppleShop/shared/util';
import { Tooltip } from '@services/MarppleShop/renderApp/components/atoms/Tooltip/Tooltip.ts';
import { shareFont } from '@services/MarppleShop/shared/typography';

interface InputStock_Edit_NoOption extends InputEditor {
  mode: typeof MODE.EDIT | typeof MODE.EDIT_TPL | typeof MODE.EDIT_TPL_INTL;
  stock_type: typeof StockType.TOTAL_STOCK;
  value: StockInputValue_Edit_NoOption[];
  readonly?: boolean;
  is_studio_worker_admin?: boolean;
}

export class Input_Stock_EditNoOption extends Base_Input_Stock<InputStock_Edit_NoOption> {
  protected override inputTemplate() {
    return html`
      <div
        class="${klass.stock_table} ${this.data.mode !== MODE.EDIT
          ? klass.edit_no_option_tpl
          : klass.edit_no_option}"
      >
        <div class="${klass.row} ${klass.header}">
          <div class="${klass.col}">재고</div>
          ${doIf(
            () => html`
              <div class="${klass.col}">
                재고 관리 번호
                ${new Tooltip({
                  id: this.data.name,
                  content: html`
                    <div class="${common_klass.tooltip_content_container} ${shareFont('14_medium')}">
                      <div class="${common_klass.tooltip_content_divider}">
                        <span>·</span>
                        <span>재고관리번호를 입력하지 않은 경우 자동생성됩니다.</span>
                      </div>
                      <div class="${common_klass.tooltip_content_divider}">
                        <span>·</span>
                        <span
                          >입고 상품을 등록한 후엔 옵션, 재고관리번호, 상품 카테고리는 수정할 수
                          없습니다.</span
                        >
                      </div>
                    </div>
                  `,
                  size: 'x_small',
                  variant: 'studio',
                })}
              </div>
            `,
            this.data.mode !== MODE.EDIT,
          )}
        </div>
        ${this.data.value.map((item, index) => {
          return html`
            <div class="${klass.row}">
              <div class="${klass.col}">
                ${stockDataUtil.numberInput({
                  index,
                  name: this.data.name,
                  value: item.stock,
                  readonly:
                    (this.data.mode === MODE.EDIT_TPL || this.data.mode === MODE.EDIT_TPL_INTL) &&
                    !this.data.is_studio_worker_admin,
                  onFocusout: (view) => {
                    this.onNumericOptionChange(view, 'stock');
                  },
                })}
              </div>
              ${doIf(
                () => html`
                  <div class="${klass.col}">
                    ${stockDataUtil.textInput({
                      index,
                      readonly: this.data.readonly,
                      name: this.data.name,
                      value: item.sku || String(item.id || ''),
                      placeholder: 'SKU',
                      onFocusout: (view) => {
                        this.onStringOptionChange(view, 'sku');
                      },
                    })}
                  </div>
                `,
                this.data.mode !== MODE.EDIT,
              )}
            </div>
          `;
        })}
      </div>
    `;
  }
}
